module.exports = __webpack_public_path__ + "img/6_002.cafa2937.webp";